export default () => {
  return {
    headers: ["Nome do produto"],
    rows: [
      ["MOBILUBE HDA 85W90 - BB 20 LTS"],
      ["MOBILUBE HD 85W140 - BB 20 LTS"],
    ],
  };
};
